export default __webpack_public_path__ + "static/media/nodejs-logo.3dc364b8.svg";